document.addEventListener("DOMContentLoaded", function () {
  const ibanInput = document.getElementById("payment_sepa_sepa_iban_number");
  const sepaRadio = document.getElementById("shop_payment_sepa");

  if (ibanInput && sepaRadio) {
    ibanInput.addEventListener("keydown", function () {
      sepaRadio.checked = true;
    });
  }
});

function submit_payment() {
  var cc_radio = document.getElementById("shop_payment_payone_cc");
  if (cc_radio && cc_radio.checked) {
    payone_cc_api_submit();
  } else {
    document.getElementById("payment_form").requestSubmit();
  }
}

function possibly_show_bic(country_select, skip_bic) {
  var bic_node = document.getElementById("payment_sepa_iban_bic");
  if (skip_bic.indexOf(country_select.value) === -1) {
    bic_node.style.display = "block";
  } else {
    bic_node.style.display = "none";
  }
}

window.submit_payment = submit_payment;
window.possibly_show_bic = possibly_show_bic;
